import React from "react";
import ReporteComisionesLiquidaciones from "../components/ReporteComisionesLiquidaciones";

const InformeComisionesLiquidaciones = () => {
  return (
    <>
      <ReporteComisionesLiquidaciones />
    </>
  );
};

export default InformeComisionesLiquidaciones;